// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables for Color Scheme */
:root {
  /* Text Colors */
  --text-primary: #2d3748;
  --text-heading: #1a202c;
  --text-secondary: #718096;

  /* Table Colors */
  --table-header-bg: #f8f8f8;
  --table-header-text: #2d3748;
  --table-row-alt: #fff;
  --table-row-white: #ffffff;
  --table-border: #e2e8f0;
  --table-hover: #f8f8f8;

  /* State Colors */
  --border-default: #d4d4d4;
  --border-hover: #cbd5e1;
  --border-focus: #3b82f6;
  --bg-focus: #eff6ff;
  --border-error: #f44336;
  --bg-error: #fef2f2;
  --bg-error-hover: #fee2e2;
  --text-muted: #9ca3af;
  --text-error: #ef4444;

  /* Scrollbar Colors */
  --scrollbar-track: #f1f1f1;
  --scrollbar-thumb: #c1c1c1;
  --scrollbar-thumb-hover: #a8a8a8;
}

body {
  font-family: 'Rubik', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
}

h1,
h2,
h3,
h4,
h5,
h6,
.MuiTypography-h1,
.MuiTypography-h2,
.MuiTypography-h3,
.MuiTypography-h4,
.MuiTypography-h5,
.MuiTypography-h6 {
  font-family: 'Rubik', sans-serif !important;
  color: var(--text-heading) !important;
}

.MuiButton-root,
.MuiInputLabel-root,
.MuiFormLabel-root {
  font-family: 'Rubik', sans-serif !important;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.fc-timegrid-axis-cushion {
  margin: 100px 0;
}

.fc-daygrid-day-events {
  height: 200px;
  overflow-y: auto;
}

.fc-event {
  border: transparent;
}

@supports (-webkit-line-clamp: 1) {
  .line-clamp {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;;EAEzB,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;;EAEtB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;;EAErB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;EAYE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;EACvB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap');\n\n/* CSS Variables for Color Scheme */\n:root {\n  /* Text Colors */\n  --text-primary: #2d3748;\n  --text-heading: #1a202c;\n  --text-secondary: #718096;\n\n  /* Table Colors */\n  --table-header-bg: #f8f8f8;\n  --table-header-text: #2d3748;\n  --table-row-alt: #fff;\n  --table-row-white: #ffffff;\n  --table-border: #e2e8f0;\n  --table-hover: #f8f8f8;\n\n  /* State Colors */\n  --border-default: #d4d4d4;\n  --border-hover: #cbd5e1;\n  --border-focus: #3b82f6;\n  --bg-focus: #eff6ff;\n  --border-error: #f44336;\n  --bg-error: #fef2f2;\n  --bg-error-hover: #fee2e2;\n  --text-muted: #9ca3af;\n  --text-error: #ef4444;\n\n  /* Scrollbar Colors */\n  --scrollbar-track: #f1f1f1;\n  --scrollbar-thumb: #c1c1c1;\n  --scrollbar-thumb-hover: #a8a8a8;\n}\n\nbody {\n  font-family: 'Rubik', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--text-primary);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.MuiTypography-h1,\n.MuiTypography-h2,\n.MuiTypography-h3,\n.MuiTypography-h4,\n.MuiTypography-h5,\n.MuiTypography-h6 {\n  font-family: 'Rubik', sans-serif !important;\n  color: var(--text-heading) !important;\n}\n\n.MuiButton-root,\n.MuiInputLabel-root,\n.MuiFormLabel-root {\n  font-family: 'Rubik', sans-serif !important;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  vertical-align: baseline;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.fc-timegrid-axis-cushion {\n  margin: 100px 0;\n}\n\n.fc-daygrid-day-events {\n  height: 200px;\n  overflow-y: auto;\n}\n\n.fc-event {\n  border: transparent;\n}\n\n@supports (-webkit-line-clamp: 1) {\n  .line-clamp {\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
